import React from 'react'
import { Box, Paper, Tooltip, Typography } from '@material-ui/core'
// import { Eye as EyeIcon } from 'react-feather'
import clsx from 'clsx'

import constants from 'constants/index'

import useStyles from './styles'

const QuestionnaireCard = ({
  questionnaire = {},
  // handleClick = () => {},
  selected = false,
  alwaysSelected = false,
}) => {
  const classes = useStyles()

  const isSelected = alwaysSelected || selected

  const status = () => {
    if (questionnaire.answerPercentage === 0) return 'Não respondido'
    if (questionnaire.status === constants.questionnaire.NOT_APPLICABLE_STATUS)
      return 'Não se aplica'

    return parseInt(questionnaire.complianceGap) + '%'
  }

  return (
    <Paper
      component={Box}
      px={3}
      py={2}
      // onClick={handleClick}
      className={clsx({
        [classes.paper]: !isSelected,
        [classes.paperSelected]: isSelected,
      })}
    >
      <Box className={classes.gridContainer}>
        <Box>
          <Tooltip title={questionnaire.kind} placement="top">
            <Typography variant="body1" className={classes.kindTypography}>
              {questionnaire.kind}
            </Typography>
          </Tooltip>
          <Typography variant="body1">{status()}</Typography>
        </Box>
        {/* <IconButton size="small">
          <EyeIcon
            className={clsx({
              [classes.icon]: !isSelected,
              [classes.iconSelected]: isSelected,
            })}
            size={24}
          />
        </IconButton> */}
      </Box>
    </Paper>
  )
}

export default QuestionnaireCard
